module.exports = __webpack_public_path__ + "img/202412_02.8c7f63c8.jpg";